// 项目管理
export default [
  {
    path: '/project',
    meta: { title: '项目管理' },
    component: () => import('../views/project/index'),
    children: [
      {
        path: '/project/formalProject',
        // name: 'list',
        meta: { title: '正式项目管理', isMenu: true },
        component: () => import('../views/project/formalProject.vue'),
      },
      {
        path: '/project/experienceProject',
        // name: 'department',
        meta: { title: '体验项目管理', isMenu: true },
        component: () => import('../views/project/experienceProject.vue'),
      },
      {
        path: '/project/detail/examineDetail',
        // name: 'position',
        meta: { title: '项目管理详情' },
        component: () => import('../views/project/detail/examineDetail.vue'),
      },
      {
        path: '/project/detail/setupDetail',
        // name: 'position',
        meta: { title: '预约设置' },
        component: () => import('../views/project/detail/setupDetail.vue'),
      },
    ],
  },
];
